import React, { memo, useRef } from 'react'

import * as SC from './styles'

const FallbackBlock = () => {
    return <SC.FallbackContainer>Fallback Block</SC.FallbackContainer>
}

export default memo(FallbackBlock)
